module.exports = {"addButton":"+ přidat novou skupinu","newGroupName":"Nova skupina","getError":"Při načítání skupin došlo k chybě"}